<template>
  <div class="write_wrap" v-loading="pageLoading">
    <!--  {{ form }}-->
    <!--    {{ TargetEmailTemplate }}-->
    <!--    {{ smallAIHeight }}-->
    <!--    {{ isExpand }}-->
    <div class="btn_list">
      <ElButton size="small" type="primary" @click="() => handleSendMail('send')" :loading="loadingSend"
                :disabled="uploadProgress">
        {{ $t('common.sent') }}
      </ElButton>
      <ElButton size="small" @click="() => handleSendMail('examine')" :loading="loadingExamine"
                :disabled="uploadProgress">
        {{ $t('common.review.submit') }}
      </ElButton>
      <ElButton size="small" @click="handleSendMail('save')" :loading="loadingSave" :disabled="uploadProgress">
        {{ $t('common.draft.save') }}
      </ElButton>
      <el-dropdown trigger="click">
    <span class="el-dropdown-link" style="margin-left: 2px">
     <ElButton size="small">{{ $t('common.annex.upload') }}</ElButton>
    </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item>
              <ElUpload
                  ref="uploadRef"
                  style="margin-left: 2px;width: 100%;height: 100%"
                  class="upload-demo"
                  :action="action"
                  :headers="{
                        'X-Access-Token': token,
                      }"
                  :on-progress="onProgress"
                  :show-file-list="false"
                  :before-upload="beforeUpload"
                  :on-error="handleUploadError"
                  :on-success="handleUploadSuccess"
                  multiple
              >
                <template #trigger>
                  <span style="padding:5px 16px">{{ $t('common.cds88') }}</span>
                </template>
              </ElUpload>
            </el-dropdown-item>
            <!--            <el-dropdown-item>上传超大附件</el-dropdown-item>-->
            <el-dropdown-item @click="handleClickSelectFileFromCloud"><span
                style="padding:5px 16px">{{ $t('common.cloud.file.select') }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <ElButton size="small" type="primary" style="margin-left: 2px" @click="createNewTask">
        {{ $t('sending.create.grouptask') }}
      </ElButton>
    </div>
    <div class="top">
      <div class="form">
        <!--        topMessageLoading-->
        <el-skeleton
            animated
            :loading="topMessageLoading"
            :throttle="{ leading: 500, trailing: 500, initVal: true }">
          <template #template>
            <div style="padding:0px 10px">
              <el-skeleton-item class="gj_loading" variant="text" style="width: 100%;"/>
              <el-skeleton-item class="gj_loading" variant="text" style="width: 100%;"/>
              <el-skeleton-item class="gj_loading" variant="text" style="width: 100%;"/>
              <el-skeleton-item class="gj_loading" variant="text" style="width: 100%;"/>
              <el-skeleton-item class="gj_loading" variant="text" style="width: 70%;"/>
            </div>
          </template>
          <template #default>
            <el-form ref="ruleFormRef" :model="form" label-width="80px" size="large">
              <el-form-item :label="`${$t('common.email.from')}:`" prop="configId">
                <el-select
                    v-model="form.configId"
                    style="width: 100%;"
                    remote
                    size="small"
                    allow-create
                    :placeholder="$t('common.please.input')"
                >
                  <el-option
                      v-for="item in userMail_dropDownOptionList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="`${$t('common.email.to')}:`" prop="to">
                <el-select
                    size="small"
                    v-model="form.to"
                    :class="[isUnRegTo?'mailselectEl':'mailselectEl_error']"
                    style="width: 100%;"
                    remote
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    :placeholder="$t('common.please.input')"
                    @focus="(event) => handleFocus(event, 'to')"
                    @change="handleBlur()"
                    :remote-method="handleSearchCustomerInput"
                    v-select-load-more="loadMore"
                    :teleported="false"
                >
                  <el-option v-for="item in customerListInput"
                             :key="item.id"
                             :label="item.email"
                             :value="item.email"
                  >
                  </el-option>
                  <div class="select-dropdown-status" v-if="customerIsCurrentInputLoading">
                    {{ loadingListText }}
                  </div>
                </el-select>
              </el-form-item>
              <el-form-item :label="`${$t('common.email.cc')}:`" prop="cc" style="position: relative">
                <template #label>
                  <div
                      style="
                  display: flex;
                  align-items: center;
                  position: absolute;
                  left:0px;
                  width: max-content !important;

                ">
                    <el-icon size="16" @click="handleSetOpen">
                      <CaretRight v-if="!open"/>
                      <CaretBottom v-else/>
                    </el-icon>
                    <div style="text-align: right;font-size: 13px;font-weight: 500;width: 34px;">{{
                        $t('common.email.cc')
                      }}:
                    </div>
                  </div>
                </template>
                <el-select
                    size="small"
                    v-model="form.cc"
                    :class="[isUnRegCc?'mailselectEl':'mailselectEl_error']"
                    style="width: 100%;"
                    remote
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    :reserve-keyword="false"
                    :placeholder="$t('common.please.input')"
                    @focus="(event) => handleFocus(event, 'cc')"
                    @change="handleBlur()"
                    :remote-method="handleSearchCustomerInput"
                    v-select-load-more="loadMore"
                    :teleported="false"
                >
                  <el-option v-for="item in customerListInput"
                             :key="item.id"
                             :label="item.email"
                             :value="item.email"
                  >
                  </el-option>
                  <div class="select-dropdown-status" v-if="customerIsCurrentInputLoading">
                    {{ loadingListText }}
                  </div>
                </el-select>
              </el-form-item>
              <template v-if="open">
                <el-form-item prop="bcc">
                  <template #label>
                    <div>{{ $t('common.email.bcc') }}:</div>
                  </template>
                  <el-select
                      size="small"
                      v-model="form.bcc"
                      :class="[isUnRegBcc?'mailselectEl':'mailselectEl_error']"
                      style="width: 100%;"
                      remote
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      :reserve-keyword="false"
                      :placeholder="$t('common.please.input')"
                      @focus="(event) => handleFocus(event, 'bcc')"
                      @change="handleBlur()"
                      :remote-method="handleSearchCustomerInput"
                      v-select-load-more="loadMore"
                      :teleported="false"
                  >
                    <el-option v-for="item in customerListInput"
                               :key="item.id"
                               :label="item.email"
                               :value="item.email"
                    >
                    </el-option>
                    <div class="select-dropdown-status" v-if="customerIsCurrentInputLoading">
                      {{ loadingListText }}
                    </div>
                  </el-select>
                </el-form-item>
              </template>
              <el-form-item :label="`${$t('common.subject')}:`" prop="subject">
                <el-input
                    :placeholder="$t('20212')"
                    maxlength="300"
                    show-word-limit
                    style="width: 100%"
                    size="small"
                    class="email_theme"
                    v-model="form.subject"
                >
                </el-input>
              </el-form-item>
              <div class="scroll-box_sp"
                   style="display: flex; align-items: center; height: 35px;overflow: scroll hidden;margin-top: 6px;">
                <el-button @click="handleSelectTemplate" size="small" type="primary"
                           style="margin: 0 10px;font-size: 13px;font-weight: normal">
                  {{ $t('common.email.template.select') }}
                </el-button>
                <el-checkbox
                    v-model="form.urgent"
                    :true-label="1"
                    :false-label="0"
                    style="margin-right: 8px;"
                >{{ $t('common.urgent') }}
                </el-checkbox
                >
                <el-checkbox
                    v-model="form.receipt"
                    :true-label="1"
                    :false-label="0"
                    style="margin-right: 8px;"
                >{{ $t('common.read.receipt') }}
                </el-checkbox
                >
                <el-checkbox
                    v-model="form.readTrack"
                    :true-label="1"
                    :false-label="0"
                    style="margin-right: 8px;"
                >{{ $t('common.read.tracking') }}
                </el-checkbox
                >
                <el-space style="font-size: 13px;color: #606266;">
                  {{ $t('common.send.timing') }}:
                  <el-date-picker
                      v-model="form.sendTime"
                      type="datetime"
                      size="small"
                      style="width: 160px;"
                      :disabled-date="disabledDate"
                      format="YYYY-MM-DD HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      :placeholder="$t('sys.tip.select.date')">
                  </el-date-picker>
                </el-space>
                <el-checkbox style="margin-left: 10px;"
                             v-model="followDayFlag"
                             :true-label="1"
                             :false-label="0"
                >
                  {{ $t('common_followup_remind') }}:
                </el-checkbox>
                <el-space style="font-weight: 700; font-size: 14px; margin-left: 10px; color: #606266;">
                  <el-input
                      v-model="sendNum"
                      class="w-50 m-2"
                      placeholder=""
                      style="width: 50px;"
                      size="small"
                  >
                    <template #suffix>
                      <div class="suffix">
                        <el-icon class="el-input__icon" style="margin-left: auto;">
                          <Calendar/>
                        </el-icon>
                        <el-date-picker
                            class="oh"
                            v-model="sendDate"
                            type="date"
                            @change="handleSendDateChange"
                            size="small"
                            format="YYYY-MM-DD HH:mm:ss"
                            :disabled-date="disabledDate"
                            value-format="YYYY-MM-DD HH:mm:ss"
                            :placeholder="$t('sys.tip.select.date')">
                        </el-date-picker>
                      </div>
                    </template>
                  </el-input>
                  <!--  -->
                  <span style="font-size: 13px;font-weight: normal">{{ $t('common.p2h3') }}</span>
                </el-space>
                <el-space style="font-size: 13px; color: #606266;margin-left: 10px">
                  {{ $t('common.remark') }}:
                  <el-input size="small" style="width: 120px;" show-word-limit maxlength="30"
                            v-model="form.remark"></el-input>
                </el-space>
                <el-space style="font-size: 13px; color: #606266;margin-left: 10px" @click="handleClickAIButton">
                  <div class="ai_button">
                    <div>
                      <img style="width:12px;height:12px;" src="@/assets/AI/aiButton@2x.png"/>
                      {{ $t('ai.email.title') }}
                    </div>
                  </div>
                </el-space>
              </div>
            </el-form>
          </template>
        </el-skeleton>
      </div>

      <div class="customer">
        <el-tabs model-value="customer" class="demo-tabs">
          <el-tab-pane :label="$t('common.customer')" name="customer">
            <div style="height: 100%">
              <el-input
                  v-model="customerName"
                  class="input"
                  size="small"
                  :placeholder="$t('common.please.input')"
                  @keyup.enter="handleSearchCustomer"
              >
                <template #suffix>
                  <el-icon class="el-input__icon" @click="handleSearchCustomer">
                    <Search/>
                  </el-icon>
                </template>
              </el-input>
              <div class="list"
                   @scroll="handleScroll"
                   ref="List"
                   :style="{ height: listHeight + 'px', overflowY: 'scroll' }"
              >
                <div v-if="customerLoading && !customerList.length" class="side-status">
                  {{ loadingListText }}
                </div>
                <div class="item" v-for="(item) in customerList"
                     @click="() => handleSelectCustomer(item)"
                     :key="item.email"
                     :class="{ 'is-selected': isSelected(item.email) }"
                >
                  <el-popover
                      placement="left"
                      :width="'max-content'"
                      trigger="hover"
                      :content="item.email"
                      effect="dark"
                      :show-after="1200"
                  >
                    <template #reference>
                      <div>
                        <span>
                          {{ item.name.match(/^(.+?)\((.+)\)$/)?.[1] || item.name }}
                        </span>
                        <span v-if="item.name.match(/^(.+?)\((.+)\)$/)"
                              style="font-weight: 500;padding: 0px 4px;">-</span>
                        <span
                            v-if="item.name.match(/^(.+?)\((.+)\)$/)"
                            style="font-weight: 600;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                          {{ item.name.match(/^(.+?)\((.+)\)$/)?.[2] || '' }}
                        </span>
                      </div>
                    </template>
                  </el-popover>
                </div>
                <div v-if="customerLoading && customerList.length" class="side-status side-status_footer">
                  {{ loadingListText }}
                </div>
                <div v-else-if="showCustomerNoMore" class="side-status side-status_footer">
                  {{ noMoreText }}
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('common.team')" name="team">
            <div>
              <el-input
                  v-model="searchTeam"
                  class="input"
                  size="small"
                  :placeholder="$t('common.please.input')"
                  @keyup.enter="handleSearchTeam"
              >
                <template #suffix>
                  <el-icon class="el-input__icon" @click="handleSearchTeam">
                    <Search/>
                  </el-icon>
                </template>
              </el-input>
              <div
                  class="list_team"
                  @scroll="handleScrollTeam"
                  ref="List"
                  :style="{ height: listHeight + 'px', overflowY: 'scroll' }"
              >
                <div v-if="tableDataTeamLoading && !tableDataTeam.length" class="side-status">
                  {{ loadingListText }}
                </div>
                <div class="item" v-for="(item) in tableDataTeam"
                     @click="() =>
                     handleSelectCustomer(item)"
                     :key="item.email"
                     :class="{ 'is-selected': isSelected(item.email) }"
                >
                  <el-popover
                      placement="left"
                      :width="'max-content'"
                      trigger="hover"
                      :content="item.email"
                      effect="dark"
                      :show-after="1200"
                  >
                    <template #reference>
                      {{ item.userName }}
                    </template>
                  </el-popover>
                </div>
                <div v-if="tableDataTeamLoading && tableDataTeam.length" class="side-status side-status_footer">
                  {{ loadingListText }}
                </div>
                <div v-else-if="showTeamNoMore && noMoreText !== '-'" class="side-status side-status_footer">
                  {{ noMoreText }}
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="editor_wrap">
      <TinyEditor v-loading="isLoadingPage" ref="tinyEditorWrite" :width="'calc(100% - 250px)'"
                  :initial-content="tinyEditorWriteContentHtmlComputed"
                  :editorId="'write'" @iframeScroll="iframeScroll"></TinyEditor>
      <!--      @iframeScroll="iframeScroll"-->
      <div class="files" ref="filesRef">
        <div class="files_title">{{ $t('common.file.list') }}</div>
        <div class="file_box file_box_upload">
          <div class="files_out_box files_out_box_layer">
            <div v-if="!multipartFiles.length" class="file-empty file-empty_hint">
              <el-empty :image-size="56" description="" />
            </div>
            <div class="file file-item" v-for="(item, index) in multipartFiles" :key="item.uid || item.url || item.name || item.fileName || index">
              <div style="display: flex;flex-direction: column;width: 100%">
                <div style="display: flex;justify-content: space-between;align-items: center">
                  <div style="display: flex;justify-content: flex-start;align-items: center;">
                    <el-icon v-if="isUploadedFile(item)"
                             color="rgba(0,0,0,.45)"
                             size="14">
                      <Link/>
                    </el-icon>
                    <el-icon v-else class="is-loading" color="rgba(0,0,0,.45)" size="14">
                      <Loading/>
                    </el-icon>
                    <el-popover
                        placement="right"
                        :width="'max-content'"
                        effect="dark"
                        trigger="hover"
                        :content="item.name"
                        show-after="1200"
                    >
                      <template #reference>
                        <a v-if="item.response||item.isCloud|| item.url" @click="downloadFiles(item.url,item.name)"
                           class="name contents text"
                           :download="true">{{
                            item.name
                          }}</a>
                        <span v-else class="name contents text" style="color: grey;pointer-events: none">{{
                            item.name
                          }}</span>
                      </template>
                    </el-popover>
                  </div>

                  <!-- 查看-->
                  <template v-if="isUploadedFile(item)">
                    <el-icon color="rgba(0,0,0,.45)" size="14" @click="handleDetailFile(item)">
                      <Search/>
                    </el-icon>
                    <el-icon color="rgba(0,0,0,.45)" size="14" @click="handleDelMul(index)">
                      <Delete/>
                    </el-icon>
                  </template>
                  <template v-else>
                    <el-icon color="rgba(0,0,0,.45)" size="14" @click="handleClickDel(index)">
                      <CircleClose/>
                    </el-icon>
                  </template>
                </div>
                <div style="margin-top: 4px" v-if="!item.isCloud && !item.url">
                  <!--              5% 等待服务端返回-->
                  <el-progress v-if="!item.response"
                               :percentage="item.response&&uploadCompleted?100:Math.max(0,item.percentage-5)"/>
                </div>
              </div>
            </div>
          </div>
          <div class="drop_area drop_area_upload">
            <el-upload
                class="upload-demo"
                drag
                style="padding:0px!important;"
                :show-file-list="false"
                :action="action"
                :headers="{
                                  'X-Access-Token': token,
                                }"
                :on-progress="onProgress"
                :before-upload="beforeUpload"
                :on-error="handleUploadError"
                :on-success="handleUploadSuccess"
                multiple
            >
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <!--    设置模版-->
    <el-dialog
        v-model="templateFlag"
        width="50vw"
        :z-index="97"
        :append-to-body="true"
        :close-on-click-modal="false"
        style="min-width: 760px"
    >
      <div class="modal_content">
        <div class="list">
          <el-tabs model-value="first" class="demo-tabs">
            <el-tab-pane :label="$t('common.email.template')" name="first">
              <ElTable
                  :data="templateList"
                  ref="templateRef"
                  @current-change="handleCurrentRowChange"
                  style="width: 100%"
                  :height="400"
                  v-loading="isLoading"
                  :header-cell-style="{'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}"
              >
                <el-table-column
                    prop="name"
                    :label="$t('common.email.templateName')"
                    width="160"
                >
                  <template #default="{ row }">
                    <el-tooltip
                        effect="dark"
                        :content="getDisplayValue(row.name)"
                        placement="top"
                        :show-after="1200"
                        :disabled="!isOverflowing(getDisplayValue(row.name))"
                        :popper-style="{
                          maxWidth: '300px',
                          maxHeight: '200px',
                          overflowY: 'auto',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word'
                        }"
                    >
                      <div
                          class="popover-content"
                          style="width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                      >
                        {{ getDisplayValue(row.name) }}
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="subject"
                    :label="$t('common.subject')"
                    width="auto"
                >
                  <template #default="{ row }">
                    <el-tooltip
                        effect="dark"
                        :content="getDisplayValue(row.subject)"
                        placement="top"
                        :show-after="1200"
                        :disabled="!isOverflowing(getDisplayValue(row.subject))"
                        :popper-style="{
                          maxWidth: '300px',
                          maxHeight: '200px',
                          overflowY: 'auto',
                          whiteSpace: 'normal',
                          wordBreak: 'break-word'
                        }"
                    >
                      <div
                          class="popover-content"
                          style="width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                      >
                        {{ row.subject }}
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="edit" :label="$t('common.cz')" :width="lang==='en'?420:320">
                  <template #default="scope">
                    <el-button link :type="scope.row.isDefault !== 1?'primary':'warning'" size="small"
                               @click.stop="handleSetDefault(scope.row)"
                    >{{ scope.row.isDefault !== 1 ? $t('common.setdefault') : $t('common.rmdefault') }}
                    </el-button
                    >
                    <el-button link type="primary" size="small" @click.stop="handleView(scope.row)">
                      {{ $t('common.preview') }}
                    </el-button>
                    <el-button link type="primary" size="small" @click.stop="handleUse(scope.row)">
                      {{ $t('common.email.use') }}
                    </el-button>
                    <el-button link type="primary" size="small" @click.stop="handleEditTemplate(scope.row)">
                      {{ $t('common.edit') }}
                    </el-button>
                    <el-button link type="danger" size="small" @click.stop="handleDel(scope.row)"
                               :loading="scope.row.isLoadingDel">
                      {{ $t('common.delete') }}
                    </el-button>
                    <el-button link type="primary" size="small" @click.stop="handleTop(scope.row)"
                               :loading="scope.row.isLoadingTop">
                      {{ $t('common.cds40') }}
                    </el-button>
                  </template>
                </el-table-column>
              </ElTable>
              <div style="width: 100%;display: flex;justify-content: flex-end">
                <Pagination v-model:modelValue="templatePageNo"
                            v-model:pageSizeValue="templatePageSize"
                            :total="total"
                            v-if="total"
                            @change="handleCurrentChange"
                            :is-show-select="false"
                            :isShowPageSize="false"
                            :isShowSelectItem="false"
                ></Pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!--        <div class="view_html" v-html="currentTemplateMail"></div>-->
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button size="small" type="primary" @click="handleInitTemplateEditor">
            {{ $t('common.email.newTemplate') }}
          </el-button>
          <el-button size="small" @click="templateFlag = false">{{ $t('common.close') }}</el-button>
        </div>
      </template>
    </el-dialog>
    <!--    模版预览-->
    <el-dialog :append-to-body="true" :z-index="99" width="75vw"
               :title="editTemplate && editTemplate.id ? $t('common.email.editTemplate') : $t('common.email.newTemplate')"
               v-model="addTemplateFlag" :top="'2em'"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
    >
      <div class="template_name" style="display: flex;flex-direction: column">
        <div style="width: 100%">
          <div class="label">{{ $t('common.email.templateName') }}：</div>
          <el-input v-model="templateName" :placeholder="$t('common.email.template.name')"/>
        </div>
        <!--      模版主题 -->
        <div style="width: 100%;margin-top: 5px">
          <div class="label">{{ $t('common.subject') }}：</div>
          <el-input v-model="subject" :placeholder="$t('common.email.template.subject')" clearable/>
        </div>
      </div>
      <div style="height: 60vh;overflow: scroll;margin-top: 15px">
        <TinyEditor ref="tinyEditorTemplate" :width="'100%'" :initial-content="tinyEditorTemplateContentHtml"
                    :editorId="'template'" :height="300" :border="false"></TinyEditor>
      </div>
      <template #footer>
        <div class="dialog-footer1">
          <el-button size="small" @click="calcelEditor">{{ $t('common.cancel') }}</el-button>
          <el-button size="small" type="primary" @click="handleSaveTemplate" :loading="isLoadingAdd">
            {{ $t('common.save') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog :title="$t('common.preview')"
               width="75vw"
               v-model="previewFlag"
               :close-on-click-modal="false"
               :top="'3em'"
    >
      <div style="height: 500px">
        <!--        <div v-html="previewContent"></div>-->
        <iframe style="width: 100%;height: 100%" :srcdoc="previewContent" frameborder="0"></iframe>
      </div>
      <template #footer>
        <div>
          <el-button
              size="small"
              @click="previewFlag = false">{{ $t('common.close') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <!--    从云文件中选择-->
    <WriteMailSelectTargetFile v-if="writeSelectTargetFileDialog" v-model="writeSelectTargetFileDialog"
                               @close="closeWriteSelectTargetFileDialog" :type="1"
                               @selectTargetFile="getSelectTargetFile" :isHeadLine="false"></WriteMailSelectTargetFile>
    <!--    创建群发模版-->
    <CreateTaskDia v-model="visibleDialog" v-if="visibleDialog" @close="close" :isHeadLine="false"
    ></CreateTaskDia>

    <!--    ai -->
    <el-drawer
        v-loading="contentLoading"
        v-model="drawer"
        direction="rtl"
        :size="smallAIWidth"
        :style="{maxWidth: '800px',minWidth: '350px',top:`calc(100vh - ${smallAIHeight})`}"
        :with-header="false"
        :modal-append-to-body="false"
        :modal="false"
        modal-class="chatAIDrawer_ap_email"
        custom-class="custom-drawer_ap_email"
        :mask-click-close="false"
    >
      <EmailAI @closeAIChat="handleClickCloseChat"
               @handleAmp="handleAmplify"
               @textFocus="handleEmailFocus"
               :smallAIHeight="smallAIHeight"
               :smallAIWidth="smallAIWidth"
               :isExpand="isExpand"
               @emailAIInsertContentToTinyMCE="handleEmailAIInsertContentToTinyMCE"
               :currentEmailDetail="form"
      />
    </el-drawer>
  </div>
</template>

<script>
import {onMounted, computed, reactive, ref, nextTick, watch, onUnmounted, defineAsyncComponent} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import dayjs from 'dayjs';
import {Calendar, Loading, Search} from '@element-plus/icons-vue';
import {useStore} from 'vuex';
import {getEmailCustomer} from '@/api/customer';
import {ElMessage, ElTable} from 'element-plus';
import {
  getMailConfigList,
  saveDraft,
  sendMail,
  getDefaultMailConfig as requestDefaultMailConfig,
  getMailDetails, tagMail,
} from "@/api/index";
import {
  requestMailSendTemplate,
  requestMailSendTemplateAdd,
  requestMailSendTemplateDelete,
  requestMailSendTemplateEdit,
  requestCommitEmailAudit,
  requestDefaultSendTemplate,
} from '@/api/mail';
import {
  audioFormat,
  downloadFile,
  excelFormat,
  imgFormat,
  pdfFormat,
  pptFormat,
  textFormat, videoFormat,
  wordFormat
} from '@/utils/file';
import {getToken} from '@/utils/auth';
import {emailReg, SLICE_NUMBER, TIME_OUT} from "@/utils/statusParams";
import TreeContact from "@/components/DiaPops/TreeContact.vue";
import CreateTeamPop from "@/components/DiaPops/CreateTeamPop.vue";
import {debouncePlus, throttle} from "@/utils/mylodash";
import WriteMailSelectTargetFile from "@/views/Cloud/Components/WriteMailSelectTargetFile.vue";
import {i18n} from "@/lang";
import CreateTaskDia from "@/views/SendGroup/compontents/CreateTaskDia.vue";
import {api as viewerApi} from "v-viewer";
import getPageTitle from "@/utils/get-page-title";
import {getTeamUserEmail} from "@/api/groups";
import createGradualInjector, {sliceHtmlSafely, splitHtmlByOriginalMessage, calculateOptimalSpan} from "@/utils/util";
import Pagination from "@/components/Pagination/index.vue";
import {Base64} from 'js-base64';
import {
  changeFirstLine, emailTemplateCut,
  removeHtmlComments,
  replaceBrToP,
  replaceEmptyPTagsWithBr,
  replaceLineBreaksWithEmptyP,
  resetCss,
} from "@/utils/TinyMCE";
import EmailAI from "@/components/EmailAI/index.vue"
import sessionStore from "@/utils/sessionStore";

const TinyEditor = defineAsyncComponent({
  loader: () => import("@/components/TinyEditor/index.vue"),
  delay: 0,
  suspensible: false,
})

let intervalId = null;
export default {
  computed: {
    i18n() {
      return i18n
    }
  },
  methods: {},
  components: {
    Pagination,
    Loading,
    TinyEditor,
    ElTable,
    CreateTaskDia,
    EmailAI,
    WriteMailSelectTargetFile,
    CreateTeamPop,
    TreeContact,
    Calendar,
    Search,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const teamId = computed(() => store.state.email.teamID);
    const lang = computed(() => store.state.system.langLocal)
    const filesRef = ref(null);
    const customerName = ref('');
    const id = ref('');
    const customerLoading = ref(false);
    const followDayFlag = ref(0);
    const form = reactive({
      // 密送列表
      bcc: [],
      // 抄送列表
      cc: [],
      followDay: 0,
      // 附件
      // multipartFiles: [
      //   // {
      //   //   name: '',
      //   //   url: ''
      //   // }
      // ],
      // 0 不回执, 1 回执
      receipt: 0,
      // 1 追踪 0 不追踪
      readTrack: 1,
      // 回复地址
      replyTo: "",
      // 发送时间
      sendTime: "",
      // 邮件主题
      subject: "",
      // 内容
      text: "",
      // 邮件类型
      textType: "TEXT/HTML; charset=utf-8",
      to: [],
      // 0 不紧急，1紧急
      urgent: 0,
      userId: 0,
      configId: '',
      remark: '',
    });
    const userMail_dropDownOptionList = ref([]);
    const templateFlag = ref(false);
    const addTemplateFlag = ref(false);
    const previewFlag = ref(false);
    const templateList = ref([]);
    const currentTemplateMail = ref('');
    const previewContent = ref('');
    const editTemplate = ref(null);
    const templateName = ref('');
    const subject = ref("")
    const mainEditor = ref(null);
    const open = ref(false);
    const customerList = ref([]);
    const multipartFiles = ref([]);
    const activeSelectProp = ref(null);
    const configMapSysUser = reactive({});
    const configIdMapUserName = reactive({});
    const mailConfigMap = reactive({});
    const sendNum = ref(0);
    const sendDate = ref('');
    const userNameMap = reactive({});
    const action = ref(`${process.env.VUE_APP_BASE_API}/sys/oss/qiniu/upload`);
    const ENABLE_GOOGLE_ATTACHMENT_SIZE_LIMIT = true;
    const GOOGLE_ATTACHMENT_MAX_SIZE_MB = 25;

    function isValidEmail(email) {
      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailReg.test(email)
    }

    function isGoogleMailSender(config) {
      if (!config) {
        return false;
      }
      const username = String(config.username || '').toLowerCase();
      const oauthType = String(config.oauthType || '').toLowerCase();
      const mailType = String(config.mailType || '').toLowerCase();
      return oauthType === 'google'
          || mailType === 'google'
          || username.includes('@gmail.com')
          || username.includes('gmail');
    }

    const isCurrentGoogleMailSender = computed(() => (
      ENABLE_GOOGLE_ATTACHMENT_SIZE_LIMIT && isGoogleMailSender(mailConfigMap[form.configId])
    ));

    const rules = ref({
      to: [
        {
          validator(rule, value, callback) {
            const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            const invalid = value.some(v => !emailReg.test(v))
            if (invalid) callback(new Error("存在非法邮箱"))
            else callback()
          },
          trigger: "change"
        }
      ]
    })


    const tinyEditorWrite = ref(null)
    const tinyEditorWriteContentHtml = ref('')
    // 有些内容需要进行格式上的转换
    // \n 转换成 br
    const tinyEditorWriteContentHtmlComputed = computed(() => {
      // 去除注释内容  模版 + 邮件内容
      let htmlDoc = removeHtmlComments(tinyEditorWriteContentHtml.value)
      // 判断是否有 是 完整的 页面
      const hasDoctype = /!doctype/i.test(htmlDoc) || /<html(?!\s+xmlns:)/i.test(htmlDoc);
      console.log('htmlDoc', hasDoctype)
      console.log(hasDoctype, 'hasDoctype')
      // 都需要 修改第一行的字体
      if (!hasDoctype) {
        const res = replaceLineBreaksWithEmptyP(htmlDoc)
        console.log(res, 'resdddddd')
        return changeFirstLine(res)
        // return res
      } else {
        const res = TargetEmailTemplate.value + replaceBrToP(targetDetailObj.value)
        console.log(changeFirstLine(res), 'changeFirstLine(res)')
        return changeFirstLine(res)
        // return res
      }
    })

    const tinyEditorTemplate = ref(null)
    const tinyEditorTemplateContentHtml = ref("")
    const getTinyEditorInstance = (editorRef) => editorRef.value?.tinyMCEEditor?.getEditor?.() || null
    const waitForTinyEditor = async (editorRef, retries = 20) => {
      while (retries > 0) {
        const editor = getTinyEditorInstance(editorRef)
        if (editor) {
          return editor
        }
        retries -= 1
        await new Promise((resolve) => setTimeout(resolve, 50))
      }
      return null
    }


    // 群发任务创建
    const visibleDialog = ref(false)
    const close = () => {
      visibleDialog.value = false
    }

    const createNewTask = () => {
      // visibleDialog.value = true;
      const payload = {
        path: '/marketing',
        query: {massOrigin: 1, step: 0}
      }
      // const routeUrl = router.resolve(payload)
      // window.open(routeUrl.href, '_blank')
      router.push(payload)
    }


    const writeSelectTargetFileDialog = ref(false);

    // 云文件选择
    const handleClickSelectFileFromCloud = () => {
      writeSelectTargetFileDialog.value = true
    }
    const closeWriteSelectTargetFileDialog = () => {
      writeSelectTargetFileDialog.value = false
    }

    // 获取选中的文件
    const getSelectTargetFile = (value) => {
      console.log(value, '发送')
      const targetArrays = value.map(item => ({
        url: item.fileExtendPath,
        name: item.fileName,
        extendSize: item.fileSize,
        isCloud: true
      }))
      multipartFiles.value = [...targetArrays, ...multipartFiles.value]
      closeWriteSelectTargetFileDialog()
    }

    const downloadFiles = async (url, filename) => {
      try {
        if (!url) {
          console.error("downloadFiles: URL is empty");
          ElMessage.error(i18n.global.t('download.failed'));
          return;
        }

        // 只替换开头 http://（不会影响 https://）
        const safeUrl = url.replace(/^http:\/\//i, "https://");

        const res = await fetch(safeUrl);

        if (!res.ok) {
          throw new Error(`HTTP error: ${res.status}`);
        }

        const blob = await res.blob();

        // 若 filename 未传 → 从 URL 自动推断文件名
        if (!filename) {
          const urlName = safeUrl.split("/").pop();
          filename = urlName || "download";
        }

        downloadFile(blob, filename);
      } catch (error) {
        console.error("downloadFiles error:", error);
        ElMessage.error(i18n.global.t('download.failed'));
      }
    };


    const beforeUpload = (file) => {
      console.log('文件：', file)
      var FileExt = file.name.replace(/.+\./, "")
      const fileSizeMB = file.size / 1024 / 1024
      const isLt5M = fileSizeMB < 100
      var extension = ['exe', 'iso'].indexOf(FileExt.toLowerCase()) === -1
      if (!extension) {
        ElMessage({
          type: 'warning',
          message: i18n.global.t('send.all.upload.ex')
        })
        return false
      }
      if (isCurrentGoogleMailSender.value && fileSizeMB > GOOGLE_ATTACHMENT_MAX_SIZE_MB) {
        ElMessage({
          type: 'warning',
          message: lang.value === 'en'
              ? `Google sender attachments cannot exceed ${GOOGLE_ATTACHMENT_MAX_SIZE_MB}MB per file.`
              : `Google 发件箱上传附件时，单个文件不能超过 ${GOOGLE_ATTACHMENT_MAX_SIZE_MB}MB。`
        })
        return false
      }
      if (!isLt5M) {
        ElMessage({
          type: 'warning',
          message: i18n.global.t('send.all.upload.over.size')
        })
        return false
      }
    }

    const customerPages = ref(1);
    const customerPageSize = ref(15)
    const customerTotalPages = ref(1)
    const customerIsCurrent = ref(false)
    const customerTotal = ref(0)
    const getSafeLocaleText = (keys, fallback = '-') => {
      for (const key of keys) {
        const value = i18n.global.t(key)
        if (value && value !== key) {
          return value
        }
      }
      return fallback
    }
    const loadingListText = computed(() => getSafeLocaleText(['common.loading.list'], 'Loading...'))
    const emptyListText = computed(() => getSafeLocaleText(['common.empty.list', 'common.noData'], '-'))
    const noMoreText = computed(() => getSafeLocaleText(['common.no.more', 'common.empty.list', 'common.noData'], '-'))
    const showCustomerNoMore = computed(() => (
      !customerLoading.value
      && customerList.value.length > 0
      && customerPages.value >= customerTotalPages.value
    ))

    async function getAllCustomer(search) {
      let payload = {
        teamId: teamId.value,
        customerName: search ? search : customerName.value,
        pageNo: customerPages.value,
        pageSize: customerPageSize.value,
      }
      if (route.query.customerId) {
        payload.customerId = route.query.customerId
      }
      try {
        customerLoading.value = true;
        const result = await getEmailCustomer(payload);
        if (!customerIsCurrent.value) {
          customerList.value = result.result.records || [];
        } else {
          customerList.value = [...customerList.value, ...result.result.records || []]
        }
        customerTotalPages.value = result.result.pages
        customerTotal.value = result.result.total;
        customerLoading.value = false;
      } catch (e) {
        customerLoading.value = false;
      } finally {
        customerLoading.value = false;
      }
    }

    // 团队列表
    const currentTeam = ref(1)
    const sizeTeam = ref(10)
    const totalTeam = ref(0)
    const tableDataTeam = ref([])
    const tableDataTeamLoading = ref(false)
    const tableDataTeamIsCurrent = ref(false)
    const tableDataTeamTotalPages = ref(1)
    const showTeamNoMore = computed(() => (
      !tableDataTeamLoading.value
      && tableDataTeam.value.length > 0
      && currentTeam.value >= tableDataTeamTotalPages.value
    ))

    async function getAllTeamUser(search) {
      let payload = {
        teamId: teamId.value,
        pageNo: currentTeam.value,
        pageSize: sizeTeam.value,
        search: searchTeam.value
      }
      try {
        tableDataTeamLoading.value = true;
        const result = await getTeamUserEmail(payload);
        if (!tableDataTeamIsCurrent.value) {
          tableDataTeam.value = result.result.records || [];
        } else {
          tableDataTeam.value = [...tableDataTeam.value, ...result.result.records || []]
        }
        tableDataTeamTotalPages.value = result.result.pages
        totalTeam.value = result.result.total;
        tableDataTeamLoading.value = false;
      } catch (e) {
        tableDataTeamLoading.value = false;
      } finally {
        tableDataTeamLoading.value = false;
      }
    }

    const customerPagesInput = ref(1);
    const customerPageSizeInput = ref(10)
    const customerTotalPagesInput = ref(1)
    const customerIsCurrentInput = ref(false)
    const customerIsCurrentInputLoading = ref(false)
    const customerTotalInput = ref(0)
    const customerListInput = ref([])

    async function getAllCustomerInput() {
      let payload = {
        teamId: teamId.value,
        email: inputSearch.value ? inputSearch.value : customerName.value,
        pageNo: customerPagesInput.value,
        pageSize: customerPageSizeInput.value
      }
      try {
        customerIsCurrentInputLoading.value = true
        const result = await getEmailCustomer(payload);
        if (!customerIsCurrentInput.value) {
          customerListInput.value = result.result.records || [];
        } else {
          customerListInput.value = [...customerListInput.value, ...result.result.records || []]
        }
        customerIsCurrentInputLoading.value = false
        customerTotalPagesInput.value = result.result.pages
        customerTotalInput.value = result.result.total;
      } catch (e) {
        customerIsCurrentInputLoading.value = false
      } finally {
        customerIsCurrentInputLoading.value = false
      }
    }


    const loadingMore = ref(false)
    const noMore = ref(false)
    const showPagination = ref(false)
    const loadMore = throttle(() => {
      console.log("more")
      if (customerTotalPagesInput.value === customerPagesInput.value) {
        return
      } else {
        customerIsCurrentInput.value = true
        customerPagesInput.value++
        getAllCustomerInput()
      }
    }, 500)

    /**
     * 客户列表分页
     *
     */
    const refScrollTop = ref(null)
    const List = ref(null)
    const resetListScroll = () => {
      const listEl = List.value
      if (!listEl) return
      if (typeof listEl.scrollTo === 'function') {
        listEl.scrollTo({top: 0})
        return
      }
      listEl.scrollTop = 0
    }
    const handleScroll = debouncePlus(async (event) => {
      const element = event.target;
      console.log("scroll", element.scrollHeight, element.scrollTop, element.clientHeight)
      refScrollTop.value = element.scrollTop;
      // const scrollTop = Math.floor(element.scrollTop);
      // const clientHeight = element.getBoundingClientRect().height;
      const tolerance = 20;
      if (element.scrollTop >= (element.scrollHeight - element.clientHeight - tolerance)) {
        if (customerTotalPages.value === customerPages.value) {
          return;
        } else {
          customerIsCurrent.value = true
          customerPages.value++;
          await getAllCustomer()
        }
      }
    }, 300)

    const handleScrollTeam = debouncePlus(async (event) => {
      const element = event.target;
      console.log("scroll", element.scrollHeight, element.scrollTop, element.clientHeight)
      refScrollTop.value = element.scrollTop;
      // const scrollTop = Math.floor(element.scrollTop);
      // const clientHeight = element.getBoundingClientRect().height;
      const tolerance = 20;
      if (element.scrollTop >= (element.scrollHeight - element.clientHeight - tolerance)) {
        if (tableDataTeamTotalPages.value === currentTeam.value) {
          return;
        } else {
          tableDataTeamIsCurrent.value = true
          currentTeam.value++;
          await getAllTeamUser()
        }
      }
    }, 300)


    const resetCurrentAboutCustomer = () => {
      customerIsCurrent.value = false
      if (customerPages.value * customerPageSize.value >= customerTotal.value) {
        if (customerPages.value) {
          customerPages.value = 1;
        }
      }
    }

    function filterString(inputString) {
      // 使用正则表达式匹配括号中的内容以及括号外的内容
      const regex = /^(.*?)\((.*?)\)(.*?)$/;
      const matches = inputString.match(regex);

      // 如果匹配成功，返回过滤后的字符串
      if (matches && matches.length === 4) {
        const prefix = matches[1].trim(); // 括号前的部分
        const suffix = matches[3].trim(); // 括号后的部分
        return `${prefix}(${suffix})`;
      } else {
        // 如果匹配失败，返回原始字符串
        return inputString;
      }
    }

    const handleSearchCustomer = throttle(async () => {
      console.log(customerName.value, 'customerName.value')
      customerIsCurrent.value = false;
      customerPages.value = 1;
      await getAllCustomer();
      // scroll 重置高度
      resetListScroll();
    }, 300)

    const searchTeam = ref("")
    const handleSearchTeam = throttle(async () => {
      console.log(searchTeam.value, 'searchTeam.value')
      tableDataTeamIsCurrent.value = false;
      currentTeam.value = 1;
      await getAllTeamUser();
      // scroll 重置高度
      resetListScroll();
    }, 300)

    const inputSearch = ref('')
    const handleSearchCustomerInput = throttle(async (search) => {
      if (search !== "") {
        inputSearch.value = search
        customerPagesInput.value = 1;
        await getAllCustomerInput(search);
        // scroll 重置高度
        resetListScroll();
      } else {
        customerListInput.value = [];
      }
    }, 300)


    const templatePageNo = ref(1);
    const templatePageSize = ref(15)
    const isCurrent = ref(false)
    const pages = ref(1);
    const total = ref(0);
    const isLoading = ref(false)
    const templateRef = ref(null)

    async function getMailTemplateList() {
      isLoading.value = true
      try {
        const result = await requestMailSendTemplate({
          pageNo: templatePageNo.value,
          pageSize: templatePageSize.value,
          teamId: teamId.value
        });
        const {records} = result.result;
        if (!isCurrent.value) {
          templateList.value = records.map(item => ({...item, isLoadingDel: false}));
        } else {
          templateList.value = [...templateList.value, ...records.map(_ => ({..._, isLoadingDel: false}))];
        }
        pages.value = result.result?.pages;
        total.value = result.result?.total;
        isLoading.value = false
        console.log('获取邮件模板', records);
      } catch (e) {
        isLoading.value = false
      }
    }

    const handleCurrentChangeTemplate = async (page) => {
      templatePageNo.value = page
      await getMailTemplateList()
    }

    // 用户是否开始滚动 标识
    const scrollStartFlag = ref(false)
    const scrollBehavior = () => {
      scrollStartFlag.value = true;
    }

    const handleTableScroll = async () => {
      console.log('scroll',)
      //  用户开始滚动
      // await store.commit("cloud/changeDisabled", false);
      if (scrollStartFlag.value) {
        if (templatePageNo.value === pages.value) {
          return;
        } else {
          isCurrent.value = true;
          templatePageNo.value++
          await getMailTemplateList();
        }
      } else {

      }
    }

    function handleCurrentRowChange(row) {
      console.log('click current', row);
      currentTemplateMail.value = row?.textContent;
    }

    function formatText(list, type) {
      console.log(list, type);
      if (!list || !list.length) {
        return '';
      }
      const infoMap = list.reduce((prev, item) => {
        if (!prev[item.mailType]) {
          prev[item.mailType] = [];
        }
        prev[item.mailType].push(item.mail);
        return prev;
      }, {});
      return infoMap[type] ? infoMap[type].join(',') : '';
    }

    // 设为默认
    async function handleSetDefault(row) {
      const result = await requestMailSendTemplateEdit({
        id: row.id,
        isDefault: row.isDefault === 1 ? 0 : 1,
        teamId: teamId.value
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      ElMessage.success(result.result);
      // await resetCurrentAbout()
      await getMailTemplateList();
      templateRef.value.setScrollTop(0)
      console.log('设为默认', result);
    }


    const TargetEmailTemplate = ref("")
    const TargetEmailTemplateSubject = ref("")

    async function getDefaultEmailTemplate() {
      const result = await requestDefaultSendTemplate({teamId: teamId.value});
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      if (result.result) {
        TargetEmailTemplate.value = result.result?.textContent || ""
        const editor = await waitForTinyEditor(tinyEditorWrite)
        if (editor) {
          try {
            await nextTick()
            tinyEditorWriteContentHtml.value = result.result?.textContent || ""
            editor.setContent(result.result?.textContent ? result.result?.textContent : "")
            TargetEmailTemplateSubject.value = result.result?.subject || ""
          } catch (e) {
            // console.log(e, 'error')
          }
        }
      }
    }


    function handleView(row) {
      previewContent.value = resetCss + replaceEmptyPTagsWithBr(row?.textContent || "");
      previewFlag.value = true;
    }


    async function handleUse(row) {
      console.log(row?.textContent, targetDetailObj.value, row, 'targetDetailObj')
      await nextTick()
      const editor = await waitForTinyEditor(tinyEditorWrite)
      if (!editor) {
        return
      }
      // tinyEditorWriteContentHtml.value = row?.textContent + targetDetailObj.value ? targetDetailObj.value : ``
      editor.setContent((row.textContent ? emailTemplateCut(row.textContent) : '') + (targetDetailObj.value !== "" ? targetDetailObj.value : ""))
      TargetEmailTemplateSubject.value = row?.subject
      // 主题
      if (TargetEmailTemplateSubject.value !== "" && TargetEmailTemplateSubject.value !== null) {
        form.subject = TargetEmailTemplateSubject.value
      }
      templateFlag.value = false;
    }

    const handleDel = async (row) => {
      row.isLoadingDel = true
      try {
        const result = await requestMailSendTemplateDelete({id: row.id, teamId: teamId.value});
        if (result.code !== 200) {
          ElMessage.error(result.message);
        } else {
          ElMessage.success(result.result);
          // await resetCurrentAbout()
          await getMailTemplateList();
          templateRef.value.setScrollTop(0)
        }
      } catch (e) {
        const msg = e?.response?.data?.message || e?.message || e;
        ElMessage.error(String(msg || '操作失败'));
      } finally {
        row.isLoadingDel = false
      }
    }

    const handleTop = async (row) => {
      row.isLoadingTop = true
      const result = await requestMailSendTemplateEdit({
        ...row,
        id: row.id,
        teamId: teamId.value,
        isTop: 1,
      });
      if (result.code !== 200) {
        row.isLoadingTop = false
        ElMessage.error(result.message);
        return;
      }
      row.isLoadingTop = false
      // ElMessage.success(result.result);
      // await resetCurrentAbout()
      await getMailTemplateList();
      templateRef.value.setScrollTop(0)
    }

    async function handleInitTemplateEditor() {
      addTemplateFlag.value = true;
      editTemplate.value = null;
      templateName.value = "";
      subject.value = ""
      await nextTick()
      // 监听更新
      tinyEditorTemplateContentHtml.value = ""
      // 内容更新
      tinyEditorTemplate.value?.tinyMCEEditor?.getEditor().setContent("")
    }

    async function handleEditTemplate(row) {
      console.log(row, '编辑');
      editTemplate.value = row;
      addTemplateFlag.value = true;
      templateName.value = row.name;
      subject.value = row.subject
      await nextTick()
      tinyEditorTemplateContentHtml.value = row?.textContent || "";
      tinyEditorTemplate.value?.tinyMCEEditor?.getEditor().setContent(row?.textContent ? row?.textContent : "")
    }

    // 获取用户邮箱列表
    function initUserMailList() {
      // currentMailId = this.mailConfigId;
      return getMailConfigList({teamId: teamId.value}).then((res) => {
        console.log(res, '获取用户邮箱列表');
        if (res.code === 200) {
          // const configId = res.data.data[0].id
          res.result = res.result || [];
          const arr = [];
          res.result.forEach((item) => {
            configMapSysUser[item.id] = item.sysUserId;
            configIdMapUserName[item.username] = item.id;
            mailConfigMap[item.id] = item;
            userNameMap[item.id] = item.username;
            arr.push({label: item.username, value: item.id});
          });
          userMail_dropDownOptionList.value = arr;
        }
      });
    }

    async function getDefaultMailConfig() {
      try {
        const result = await requestDefaultMailConfig({teamId: teamId.value});

        // 1️⃣ 请求失败 or 返回空
        if (!result || result.code !== 200) {
          ElMessage.error(result?.msg || i18n.global.t('sys.default.email.message.error'));
          return;
        }

        // 2️⃣ result.result 为空
        const config = result.result;
        if (!config) {
          // ElMessage.warning(i18n.global.t('sys.default.email.message'));
          // form.configId = '';
          return;
        }

        // 3️⃣ 安全解构
        const {
          id,
          username,
          sysUserId
        } = config;

        form.configId = id ?? '';
        form.userId = sysUserId ?? '';
        form.from = username ?? '';
        console.log(config, 'config')
      } catch (err) {
        console.error('获取默认邮箱配置异常：', err);
        // ElMessage.error('获取默认邮箱配置异常');
      }
    }

    const isLoadingAdd = ref(false)

    const handleSaveTemplate = throttle(async () => {
      const editor = await waitForTinyEditor(tinyEditorTemplate)
      if (!editor) {
        return
      }
      const html = editor.getContent()
      const requestApi = editTemplate.value ? requestMailSendTemplateEdit : requestMailSendTemplateAdd;
      const params = editTemplate.value ? {
        id: editTemplate.value.id,
        name: templateName.value,
        subject: subject.value,
        textContent: html,
        teamId: teamId.value
      } : {name: templateName.value, subject: subject.value, teamId: teamId.value, textContent: html};
      let result = null;
      try {
        isLoadingAdd.value = true
        result = await requestApi(params);
        isLoadingAdd.value = false
      } catch (e) {
        isLoadingAdd.value = false
      }
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      ElMessage.success(result.result);
      templateName.value = '';
      subject.value = '';
      editTemplate.value = null;
      addTemplateFlag.value = false;
      // await resetCurrentAbout()
      await getMailTemplateList();
      templateRef.value.setScrollTop(0)
    }, TIME_OUT)

    const calcelEditor = () => {
      editTemplate.value = null;
      addTemplateFlag.value = false;
      // tinyEditorTemplate.value.tinyMCEEditor.getEditor().setContent("")
    }

    function disabledDate(date) {
      return date.getTime() < Date.now();
    }

    async function handleSelectTemplate() {
      templateFlag.value = true;
      await getMailTemplateList()
      templateRef.value && templateRef.value.$refs.bodyWrapper.addEventListener("mousewheel", scrollBehavior, {passive: true})
    }


    // const rules = reactive({
    //   subject: [{required: true, trigger: ["blur", "change"]}],
    // });


    async function requestTagMail(id) {
      const result = await tagMail({
        isRead: 1,
        mailIdList: [id],
      });
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis')
    }

    /**
     * 发送、保存邮件
     * @param type  {String}  ['send': 发送, 'save': 保存，examine: 审核]
     * @param cb    {Function || null}  回调函数
     */
    const loadingSend = ref(false);
    const loadingExamine = ref(false);
    const loadingSave = ref(false);
    const ruleFormRef = ref(null);
    const pageLoading = ref(false);

    function validateEmails(emailArray, type) {
      const invalidEmails = emailArray.filter(item => !emailReg.test(item.trim()))
      const isRegMap = {
        to: isUnRegTo,
        cc: isUnRegCc,
        bcc: isUnRegBcc
      }

      if (invalidEmails.length >= 1) {
        const targetText = type === 'to' ? i18n.global.t('common.email.to') : activeSelectProp.value === 'cc' ? i18n.global.t('common.email.cc') : i18n.global.t('common.email.bcc')
        ElMessage.error(i18n.global.t('send.all.delete.no.email', {target: targetText}))
        const filtered = emailArray.filter(item => emailReg.test(item.trim())).map(item => item.trim())
        isEmailReg.value = true
        pageLoading.value = false

        isRegMap[type].value = true;
        return {valid: false, result: filtered}
      }
      isRegMap[type].value = false;
      return {valid: true, result: emailArray.map(item => item.trim())}
    }

    // 通用的邮箱校验和过滤函数
    // function validateEmailList(list, label, emailReg) {
    //   // 取出非法邮箱
    //   const invalidEmails = list
    //       .map(item => item.email.trim())
    //       .filter(email => !emailReg.test(email));
    //   // 提示
    //   if (invalidEmails.length > 0) {
    //     ElMessage.warning(`${label}${i18n.global.t('sys.message.error.emailbox')}：${invalidEmails.join('、')}，${i18n.global.t('sys.message.auto.delete')}`);
    //   }
    //
    //   // 返回过滤后的数组
    //   return list.filter(item => emailReg.test(item.email));
    // }

    const handleSendMail = throttle(async (type, cb = null) => {
      pageLoading.value = true
      // 通用 IE 内核检测（Trident）
      const isIEKernel = /Trident/.test(navigator.userAgent) || /MSIE/.test(navigator.userAgent);
      if (isIEKernel) {
        ElMessage.warning(i18n.global.t('common.brow.inner.warning'));
        return;
      }

      // 验证表单
      ruleFormRef.value?.validate((valid) => {
        if (!valid) {
          pageLoading.value = false
          return;
        }

        // 配置校验
        if (!form.configId) {
          ElMessage.error(i18n.global.t('send.all.target.username'));
          pageLoading.value = false
          return;
        }

        // 收件人校验
        if (!form.to || form.to.length === 0) {
          ElMessage.error(i18n.global.t('common.email.recipientNotEmpty'));
          pageLoading.value = false
          return;
        }

        // 邮箱格式校验
        // 校验 to
        let res = validateEmails(form.to, 'to')
        // form.to = res.result
        if (!res.valid) return  // 遇到非法邮箱就退出，不继续执行

        // 校验 cc
        res = validateEmails(form.cc, 'cc')
        // form.cc = res.result
        if (!res.valid) return

        // 校验 bcc
        res = validateEmails(form.bcc, 'bcc')
        // form.bcc = res.result
        if (!res.valid) return

        // 定时时间校验
        if (form.sendTime) {
          const now = new Date();
          const sendTime = new Date(form.sendTime);
          if (sendTime <= now) {
            ElMessage.error(i18n.global.t('write.sendTime.bj'));
            pageLoading.value = false
            return;
          }
        }

        if (type === 'save') {
          form.groupId = '2';
        }

        const timestamp = Date.now();

        const data = {
          ...form,
          subject: form.subject ? form.subject.trim() : '',
          to: mapRecipients(form.to, "to"),
          cc: form.cc ? mapRecipients(form.cc, "cc") : [],
          bcc: form.bcc ? mapRecipients(form.bcc, "bcc") : [],
          multipartFiles: multipartFiles.value,
          userId: configMapSysUser[form.configId],
          from: userNameMap[form.configId],
          text: (tinyEditorWrite.value?.tinyMCEEditor?.getEditor()?.getContent() || '') +
              (injector.value ? injector.value.getStatus().remainingContent : ''),
          teamId: teamId.value,
          followDay: followDayFlag.value === 1 ? trueTargetFollowDay.value : 0,
          isRepeat: route.query.mailType === "2" || route.query.mailType === "3" ? 1 : 0,
          timeKey: timestamp
        };
        // 判断是否有非法的邮箱，并进行删除操作
        // data.to = validateEmailList(data.to, i18n.global.t('common.email.to'), emailReg);
        // data.cc = validateEmailList(data.cc, i18n.global.t('common.email.cc'), emailReg);
        // data.bcc = validateEmailList(data.bcc, i18n.global.t('common.email.bcc'), emailReg);
        data.text = replaceEmptyPTagsWithBr(data.text);
        // data.text = sliceHtmlSafely(data.text, SLICE_NUMBER);
        console.log(data.text.length, 'data.text.length')
        // return;
        const requestApi = type === "send" ? sendMail : type === 'examine' ? requestCommitEmailAudit : saveDraft;
        const loadingFlag = type === "send" ? loadingSend : type === 'examine' ? loadingExamine : loadingSave;
        const infoText = type === "send" ? i18n.global.t('common.email.list.sendSuccessOk') : type === 'examine' ? i18n.global.t('sys.message.success.email.sh') : i18n.global.t('sys.message.success');
        const isSp = type === 'save'|| type==='examine';

        if (route.query.mailType === '1') data.replyMailId = route.query.id;
        if (route.query.mailType === '2') data.id = route.query.id;

        loadingFlag.value = true;
        requestApi(data)
            .then(async (res) => {
              loadingFlag.value = false;
              if (res.code === 200) {
                let emailId = type === 'save' ? res.result.id : res.message;
                if (!route.query.type && route.query.isRead === '0') {
                  await requestTagMail(route.query.id);
                }
                // if (type === 'examine') {
                //   ElMessage.success(infoText);
                //   router.push('/email/examine');
                // } else {
                  const queryObj = {
                    id: route.query.id,
                    customerId: route.query.customerId,
                    emailArray: [...data.to, ...data.cc, ...data.bcc],
                    text: infoText,
                    flag: route.query.flag,
                    sendTime: form.sendTime,
                    emailId,
                    isSp
                  };
                  // if (route.query.isNoArchive) {
                  //   queryObj.isNoArchive = route.query.isNoArchive
                  // }
                  const encrypted = Base64.encode(JSON.stringify(queryObj));
                  setTimeout(() => {
                    pageLoading.value = false
                    router.push({path: '/success', query: {q: encrypted}});
                  }, TIME_OUT)
                // }
                if (cb) cb("success");
              } else {
                ElMessage.error(res.message);
              }
            })
            .catch(e => {
              loadingFlag.value = false;
              setTimeout(() => {
                router.push({path: "/email/draft"});
              }, TIME_OUT);
            })
            .finally(() => {
              loadingFlag.value = false;
            });
      });
    }, TIME_OUT);
    const mapRecipients = (recipients, type) => {
      const customerListMap = customerList.value.reduce((prev, item) => {
        prev[item.email] = item
        return prev;
      }, {});

      return recipients.map(item => {
        const mappedItem = customerListMap[item] ? {...customerListMap[item]} : {name: item.trim(), email: item.trim()};
        return {
          ...mappedItem
        };
      });
    };

    function handleUploadError(error) {
      try {
        const status = error?.status || error?.response?.status;
        const rawMsg = String(error?.message || error || '');
        const isFailToPost = /fail to post/i.test(rawMsg) && rawMsg.includes('/sys/oss/qiniu/upload');
        if (status === 413 || isFailToPost) {
          ElMessage.error('上传失败：文件过大，请压缩后重试或更换更小的文件。');
          return;
        }
      } catch (e) {
      }
      const msg = typeof error === 'string'
          ? error
          : (error?.message || error?.statusText || '上传失败，请稍后重试');
      ElMessage.error(String(msg || '上传失败，请稍后重试'));
    }

    function isUploadedFile(item) {
      return Boolean((item.percentage === 100 && item.response) || item.isCloud || item.url)
    }

    const uploadCompleted = ref(false)

    async function handleUploadSuccess(e) {
      console.log('上传成功', e.result, multipartFiles.value);
      if (e.code === 200) {
        uploadCompleted.value = true;
        const res = mergeArrays(multipartFiles.value, [e.result])
        console.log(res, 'res')
        // 注意 multipartFiles 中有两种结构的数据类型
        res.forEach(file => {
          if (!file.extendSize)
            file.extendSize = file.size;
        });
        multipartFiles.value = res;
        if (multipartFiles.value.length > 0) {
          //   如果有主题那么就 展示主题，否则则 展示 第一个附件 的名字
          const firstFileName = multipartFiles.value[0].name
          if (form.subject === "" && firstFileName) {
            form.subject = firstFileName
          }
        }
      }
    }

    // 合并数组并处理重复项
    function mergeArrays(array1, array2) {
      // 合并数组并处理重复项
      return array1.map((item1) => {
        const item2 = array2.find(
            (item2) => item2.name === item1.name && item2.size === item1.size
        );
        if (item2) {
          // 如果 filename 和 name 相同，则执行特定操作
          return {...item1, ...item2};
        } else {
          // 如果找不到匹配项，则保留原始数据
          return item1;
        }
      });
    }

    // 文件进度
    const uploadProgress = ref(false)

    function onProgress(progressEvent, file) {
      // 如果文件已被取消，则停止所有逻辑
      if (file.__canceled) return;

      uploadProgress.value = true;

      // 不在列表里就加入列表（首次）
      if (!multipartFiles.value.some(item => item.uid === file.uid)) {
        multipartFiles.value.push(file);
      }

      // 计算上传进度
      file.percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);

      uploadProgress.value = file.percentage !== 100;
    }

    const handleClickDel = (index) => {
      const file = multipartFiles.value[index];
      if (file) {
        file.__canceled = true;   // 标记该文件已被取消
        uploadProgress.value = false;
        // uploadRef.value.abort(file);
      }
      multipartFiles.value.splice(index, 1);
    };

    function handleDelMul(index) {
      multipartFiles.value.splice(index, 1);
    }


    function handleSelectCustomer(item) {
      if (!activeSelectProp.value) {
        return;
      }
      if (!form[activeSelectProp.value].includes(item.email)) {
        form[activeSelectProp.value].push(item.email);
      }
      console.log('click', item, form[activeSelectProp.value]);
      updateListHeight()
    }

    function handleFocus(event, type) {
      console.log('聚焦', type);
      console.log(form.to, 'form.to,focus')
      activeSelectProp.value = type;
    }

    const isEmailReg = ref(false)

    const isUnRegTo = ref(false)
    const isUnRegCc = ref(false)
    const isUnRegBcc = ref(false)

    const errorEmailsTo = ref([])
    const errorEmailsCc = ref([])
    const errorEmailsBcc = ref([])

    function handleBlur() {
      let target = form[activeSelectProp.value]
      console.log(activeSelectProp, target, 'activeSelectProp')
      const isRegMap = {
        to: isUnRegTo,
        cc: isUnRegCc,
        bcc: isUnRegBcc
      }
      const errorEmailsMap = {
        to: errorEmailsTo,
        cc: errorEmailsCc,
        bcc: errorEmailsBcc
      }
      const targetArray = target.filter(item => !emailReg.test(item.trim()));
      if (targetArray.length >= 1) {
        const targetText = activeSelectProp.value === 'to' ? i18n.global.t('common.email.to') : activeSelectProp.value === 'cc' ? i18n.global.t('common.email.cc') : i18n.global.t('common.email.bcc')
        // 提示邮件不合规
        ElMessage.error(i18n.global.t('send.all.delete.no.email', {target: targetText}))
        errorEmailsMap[activeSelectProp.value].value = targetArray;
        isRegMap[activeSelectProp.value].value = true;
        isEmailReg.value = true
      } else {
        isEmailReg.value = true;
        isRegMap[activeSelectProp.value].value = false;
      }
    }

    function originalEmailTemp(info) {
      let {from, to, cc, subject, content, createTime} = info;
      const ccTmp = cc.length
        ? `<div><b>${i18n.global.t('common.email.cc')}:</b>&nbsp;${cc.split(',').reduce((t, n) => t + `;&nbsp;${n}`)}</div>`
        : '';
      const toTmp = to
        .split(',')
        .map((n) => `&nbsp;${n}`)
        .join(';');

      return [
        '<p class="tiny_edit_br_simulation_p_original_message"></p>',
        `<div class="original_message_flags_mail_talk_hz" style="background:#F5F5F5;padding:8px;color:#444;font-family: 'Microsoft YaHei', 'Helvetica Neue', 'PingFang SC', sans-serif;">`,
        `<div style="padding:2px 0;">------------------ ${i18n.global.t('common.email.originalMessage')} ------------------</div>`,
        `<div><b>${i18n.global.t('common.email.from')}:</b>&nbsp;${from}</div>`,
        `<div><b>${i18n.global.t('common.date')}:</b>&nbsp;${createTime}</div>`,
        `<div><b>${i18n.global.t('common.email.to')}:</b>&nbsp;${toTmp}</div>`,
        ccTmp,
        `<div><b>${i18n.global.t('common.subject')}:</b>&nbsp;${subject}</div>`,
        '</div>',
        '<p class="tiny_edit_br_simulation_p_original_message"></p>',
        content,
      ].join('');
    }

    const contentLoading = ref(false)
    const topMessageLoading = ref(false)
    const currentTargetEmailDetail = ref(null)

    const targetDetailObj = ref("")
    const injector = ref("")

    async function getDetail() {
      contentLoading.value = true;
      topMessageLoading.value = true
      const result = await getMailDetails({id: route.query.id});

      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      currentTargetEmailDetail.value = result.result;
      const type = route.query.type;
      const mailType = route.query.mailType;
      const flag = route.query.flag;

      // 设置页面标题
      const titleMap = {
        forward: i18n.global.t('common.write.forward'),
        replayAll: i18n.global.t('common.write.replayAll'),
        resend: i18n.global.t('common.write.resend'),
        follow: i18n.global.t('common.write.follow'),
      };

      document.title = getPageTitle(titleMap[type] || i18n.global.t('common.write.send.replay'));

      const resultData = result.result;
      const mailRecipientVOList = resultData.mailRecipientVOList || [];
      const mailExtendList = type ? resultData.mailExtendList || [] : [];
      const mailBody = resultData.mailBody || {};

      const personInfo = mailRecipientVOList.reduce((prev, item) => {
        (prev[item.mailType] = prev[item.mailType] || []).push(item);
        return prev;
      }, {});

      let index = null;
      // 目标邮箱 过滤 默认绑定邮箱、空邮箱
      const formatRecipientList = (list, type) =>
          formatText(list, type).split(",").filter(item => item !== userNameMap[form.configId] && item);
      // // ======================= 设置 configId =======================      //回复
      if ((type !== 'forward' && type !== 'follow' && type !== 'editMail') || (mailType === "1") || (mailType === "3" && type !== "resend")) {
        console.log('flag--1')
        if (personInfo.to) {
          console.log('flag--2')
          personInfo.to.forEach(item => {
            index = userMail_dropDownOptionList.value.findIndex(el => el.label === item.mail);
          });
          // 这里需要注意 收件 和 已发送
          // const targetEmail = mailType === "3" ? : mailBody.from

          const fromIndex = userMail_dropDownOptionList.value.findIndex(item => item.label === mailBody.from);
          // 抄送人中
          console.log(formatText(mailRecipientVOList, 'cc'), 'formatText(mailRecipientVOList, \'cc\')')
          const ccArray = formatText(mailRecipientVOList, 'cc').split(",")
          const findCCIndex = userMail_dropDownOptionList.value.findIndex(item => ccArray.includes(item.label))
          console.log(fromIndex, 'fromIndex', userMail_dropDownOptionList.value, mailBody.from, personInfo.to, index)
          // 如果找到了绑定的邮箱，且邮箱不在 收件人中 已发送 重发 比较特殊
          if (fromIndex !== -1 && !userMail_dropDownOptionList.value[index] && index !== -1 || (((mailType === '3' || mailType === "2") && type === "resend"))) {
            console.log('flag--4')
            form.configId = configIdMapUserName[userMail_dropDownOptionList.value[fromIndex]?.label];
          } else if (userMail_dropDownOptionList.value[index]) {
            // 收件箱
            console.log('flag--5')
            form.configId = configIdMapUserName[userMail_dropDownOptionList.value[index]?.label];
          } else if (mailType === '3') {
            form.configId = userMail_dropDownOptionList.value[fromIndex]?.value
          } else {
            console.log('flag-here')
            console.log(userMail_dropDownOptionList.value, 'flag', mailBody.mailConfigId)
            // 可能在抄送人里面
            // form.configId = userMail_dropDownOptionList.value[findCCIndex]?.value
            form.configId = mailBody.mailConfigId
          }
        }
      } else if (mailBody) {
        console.log('flag--3')
        // 空白邮件填写
        console.log(userMail_dropDownOptionList.value, 'userMail_dropDownOptionList.value')
        form.configId = userMail_dropDownOptionList.value[0].value;
      }
      console.log(form.configId, 'form.configId', userMail_dropDownOptionList.value)
      // ======================= 设置收件人 =======================
      const getDefaultTo = () => {
        if (mailType === "3" && type !== 'resend' || flag === "again") {
          console.log('formatRecipientList(mailRecipientVOList, \'to\')', formatRecipientList(mailRecipientVOList, 'to'), ...personInfo.to.filter(item => item.mail !== userNameMap[form.configId]).map(_ => _.mail))
          return formatRecipientList(mailRecipientVOList, 'to');
        }
            // else if ((type === 'resend' && (mailType === "1" || mailType === "4")) && mailBody.from) {
            //   return [mailBody.from];
        // }
        else if (['resend', 'follow', 'editMail'].includes(type)) {
          return personInfo.to?.map(item => item.mail) || [];
        } else if (mailBody.from) {
          return [mailBody.from];
        }
        return [];
      };

      console.log(formatText(mailRecipientVOList, 'cc'), Array.from(new Set([...formatRecipientList(mailRecipientVOList, 'cc'), mailBody.from])), 'Array.from(new Set([...formatRecipientList(mailRecipientVOList, \'cc\'), mailBody.from]))')

      form.to = getDefaultTo();

      // 收件箱
      const inboxData = Array.from(new Set([...formatRecipientList(mailRecipientVOList, 'cc'), ...formatRecipientList(mailRecipientVOList, 'to')])).filter(item => item !== userNameMap[form.configId] && item)
      // const inboxData = Array.from(new Set([...formatRecipientList(mailRecipientVOList, 'cc')])).filter(item => item !== userNameMap[form.configId] && item)
      // 已发送
      const sentData = Array.from(new Set([...formatRecipientList(mailRecipientVOList, 'cc'), mailBody.from])).filter(item => item !== userNameMap[form.configId] && item);
      // const sentData = Array.from(new Set([...formatRecipientList(mailRecipientVOList, 'cc')])).filter(item => item !== userNameMap[form.configId] && item);

      form.cc = (type === "replayAll" && mailType === "3") ? sentData
          : (type === "replayAll" && mailType === "1") ? inboxData
              : (type === "replayAll" && mailType === "4") ? (mailBody.originalPosition === 1 ? inboxData : mailBody.originalPosition === 3 ? sentData : [])
                  : flag === "again"
                      ? formatRecipientList(mailRecipientVOList, 'cc')
                      : personInfo.cc && (
                          (type === "replayAll") ||
                          (type === "follow") ||
                          (type === 'editMail') ||
                          (type === 'resend' && flag !== 'again')
                      )
                          ? personInfo.cc.map(item => item.mail)
                          : [];

      console.log(formatText(mailRecipientVOList, 'bcc'), 'formatRecipientList(mailRecipientVOList, \'bcc\')')
      form.bcc = flag === "again"
          ? formatText(mailRecipientVOList, 'bcc').split(",").filter(_ => _ !== '')
          : personInfo.bcc && (
              (type === "replayAll") ||
              (type === "follow") ||
              (type === 'editMail') ||
              (type === 'resend' && flag !== 'again')
          )
              ? personInfo.bcc.map(item => item.mail)
              : [];

      // ======================= 其他字段处理 =======================
      form.urgent = mailBody.urgent ? 1 : 0;
      form.receipt = mailBody.receipt ? 1 : 0;
      console.log(type, 'typeddddddd')
      form.sendTime = (type === 'resend' || type === 'replayAll' || type === undefined) ? '' : mailBody.sendTime;
      const followDiff = mailBody.followTime
          ? Math.ceil(Math.abs((new Date(mailBody.followTime) - new Date()) / 1000 / 3600 / 24))
          : 0;
      followDayFlag.value = followDiff > 0 ? 1 : 0;
      form.followDay = mailBody.followTime !== null ? followDiff : 0;
      handleSendDateChange(mailBody.followTime || dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"));
      form.remark = mailBody.remark;

      // ======================= 附件处理 =======================
      if (['forward', 'resend'].includes(type)) {
        multipartFiles.value = mailExtendList.filter(_ => _.url).map(item => ({
          name: item.name,
          url: item.url,
          extendSize: item.extendSize,
        }));
      }

      // ======================= 主题处理 =======================
      form.subject = flag === "again"
          ? ""
          : ['editMail', 'resend'].includes(type)
              ? mailBody.subject
              : `Re:` + mailBody.subject;

      if (type === "replayAll" && mailType !== "3") {
        // form.to = [
        //   mailBody.from,
        //   ...personInfo.to.filter(item => item.mail !== userNameMap[form.configId]).map(_ => _.mail),
        // ];
      }

      if (type === 'forward') {
        form.to = [];
        form.cc = [];
        form.bcc = [];
        form.status = 1;
        form.subject = `Fw:` + mailBody.subject;
      }

      if (type === 'replay') {
        form.to = personInfo.to
            ? personInfo.to.map(item => item.mail).filter(item => !configUserMail[item])
            : [];
      }
      topMessageLoading.value = false
      // ======================= 正文内容 =======================
      console.log(type === "resend" && ["2", "3"].includes(mailType), 'type === "resend" && ["2", "3"].includes(mailType)')
      form.content = (type === "resend" && ["2", "3"].includes(mailType))
          ? mailBody.content : `<br/><br/>${originalEmailTemp({
            ...mailBody,
            // subject: type === 'forward' ? `Fw:` + mailBody.subject : `Re:` + mailBody.subject,
            subject: mailBody.subject,
            cc: formatText(mailRecipientVOList, 'cc'),
            to: formatText(mailRecipientVOList, 'to'),
          })}`;
      if (flag !== "again") {
        // const sliceHtml = sliceHtmlSafely(form.content, SLICE_NUMBER);
        targetDetailObj.value = form.content
        await nextTick();
        const editor = await waitForTinyEditor(tinyEditorWrite)
        console.log(editor, 'tinyEditorWrite')
        if (!editor) return;
        console.log('form.content', removeHtmlComments(form.content))
        const fullHtml = (emailTemplateCut(TargetEmailTemplate.value) ?? '') + removeHtmlComments(form.content);
        // 邮件模板存在 或者 重发邮件
        // const isHaveTemplate = TargetEmailTemplate.value !== "" || (type === "resend" && ["2", "3"].includes(mailType))
        
        try {
          // 先用默认 span=3 进行初步分割，获取 marker 数量
          const initialResult = splitHtmlByOriginalMessage(fullHtml, 3, true);
          const markerCount = initialResult.blocks.length;
          console.log(splitHtmlByOriginalMessage(form.content, 1, true).contents, 'asdfaklsjdfklasjdfklasjfklas')
          // 智能计算最佳分页大小
          const optimalSpan = calculateOptimalSpan(fullHtml, markerCount, 3);
          
          console.log('📊 智能分页分析:', {
            htmlLength: fullHtml.length,
            markerCount: markerCount,
            defaultSpan: 3,
            optimalSpan: optimalSpan,
            sizeInKB: (fullHtml.length / 1024).toFixed(2) + 'KB'
          });
          
          // 使用优化后的 span 重新分割
          const {blocks, contents} = optimalSpan === 3 
            ? initialResult 
            : splitHtmlByOriginalMessage(fullHtml, optimalSpan, true);
          
          console.log('📊 分割结果统计:', {
            blocksCount: blocks.length,
            contentsCount: contents.length,
            contentLengths: contents.map((c, i) => `第${i+1}页: ${(c.length/1024).toFixed(2)}KB`),
            totalLength: fullHtml.length
          });
          
          if (contents.length === 0) {
            console.warn('⚠️ 分割后内容为空，使用原始内容');
            injector.value = createGradualInjector(tinyEditorWriteContentHtml, [fullHtml]);
          } else {
            injector.value = createGradualInjector(tinyEditorWriteContentHtml, contents);
          }
          
          const injected = injector.value.injectNextChunk(editor);
          const status = injector.value.getStatus();
          
          console.log('📝 首次注入结果:', {
            injected,
            ...status,
            firstPageSize: contents[0] ? (contents[0].length / 1024).toFixed(2) + 'KB' : '0KB'
          });
          
        } catch (error) {
          console.error('❌ 内容分割或注入失败:', error);
          // 降级处理：直接注入完整内容
          console.log('🔄 降级处理：使用完整内容一次性加载');
          injector.value = createGradualInjector(tinyEditorWriteContentHtml, [fullHtml]);
          injector.value.injectNextChunk(editor);
        }
        
        contentLoading.value = false;
      }
    }

    const iframeScroll = () => {
      if (targetDetailObj.value !== '' && injector.value) {
        const editor = tinyEditorWrite.value?.tinyMCEEditor?.getEditor();
        
        if (!editor) {
          console.warn('⚠️ 编辑器实例不存在');
          return;
        }
        
        if (!injector.value.hasMore()) {
          // 所有内容加载完成，输出性能统计
          const perfStats = injector.value.getPerformanceStats();
          console.log('✅ 所有内容已加载完成 - 性能统计:', perfStats);
          return;
        }
        
        console.log('📜 滚动触发，准备注入下一页');
        
        const injected = injector.value.injectNextChunk(editor);
        const status = injector.value.getStatus();
        
        console.log('📝 滚动注入结果:', {
          injected,
          currentPage: status.currentPage,
          totalPages: status.totalPages,
          percentage: status.percentage + '%',
          remainingPages: status.remainingPages
        });
        
        // 如果这是最后一页，输出完整的性能统计
        if (!injector.value.hasMore()) {
          const perfStats = injector.value.getPerformanceStats();
          console.log('🎉 内容加载完成 - 完整性能报告:', perfStats);
        }
      }
    }

    const trueTargetFollowDay = ref(0)

    watch(() => sendNum.value, (newVal) => {
      console.log(newVal, 'newVal')
      followDayFlag.value = newVal > 0 ? 1 : 0;
      trueTargetFollowDay.value = newVal - 0;
      if (!Number(newVal)) {
        return;
      }
      const curDate = new Date().setHours(0, 0, 0, 0);
      const totalDate = new Date(curDate + Number(newVal) * 24 * 60 * 60 * 1000);
      sendDate.value = dayjs(totalDate).format('YYYY-MM-DD');
    });

    function handleSendDateChange(val) {
      const counts = new Date(val).setHours(0, 0, 0, 0) - new Date().setHours(0, 0, 0, 0);
      sendNum.value = Math.floor(counts / (24 * 60 * 60 * 1000));
      followDayFlag.value = sendNum.value > 0 ? 1 : 0;
      console.log(val, sendNum.value, 'val');
      console.log(counts / (24 * 60 * 60 * 1000), '数量');
    }


    function handleSetOpen() {
      open.value = !open.value;
      nextTick(() => {
        try {
          const editorWrap = document.getElementsByClassName('editor_wrap')[0];
          const height = editorWrap.clientHeight - 42;
          mainEditor.value.change.target.parentNode.style.height = height + 'px';
          mainEditor.value.change.target.parentNode.style.minHeight = height + 'px';
          mainEditor.value.change.target.style.height = height + 'px';
          mainEditor.value.change.target.style.minHeight = height + 'px';
        } catch (e) {

        }
      })
    }

    watch(() => teamId.value, () => {
      console.log('组件团队ID 监听', teamId.value);
      resetCurrentAboutCustomer()
      getAllCustomer();
      getDefaultMailConfig();
    });

    const isLoadingPage = ref(false)
    const STORAGE_KEY = 'email_ai_loading_text_shown'
    onMounted(async () => {
      isLoadingPage.value = true
      try {
        // 邮件助手 AI 首次标识
        sessionStore.remove(STORAGE_KEY)
        // 获取所有邮箱配置列表
        await initUserMailList();
        console.log('路由信息', route.query.id, userMail_dropDownOptionList);
        if (teamId.value) {
          // 指定客户
          getAllCustomer();
          // 指定团队成员
          getAllTeamUser()
          await getDefaultMailConfig();
          // 重发不用 所有重发不需要导入模版
          if (route.query.mailType !== '2' && (route.query.mailType !== '3' || (route.query.mailType === '3' && route.query.type !== "resend"))) {
            await getDefaultEmailTemplate();
          }
          if (route.query.id) {
            await getDetail();
          }
          // 主题
          if (TargetEmailTemplateSubject.value !== "" && TargetEmailTemplateSubject.value !== null) {
            form.subject = TargetEmailTemplateSubject.value
          }

          if (String(route.query.inviteFlag) === '1' && String(route.query.type) === 'invite_friend') {
            const inviteLink = String(route.query.inviteLink || '')
            const safeInviteLink = inviteLink.replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            form.subject = '邀请你加入 MailTalk｜一站式全球客户沟通与管理平台'
            await nextTick()
            const editor = tinyEditorWrite.value?.tinyMCEEditor?.getEditor?.()
            if (editor) {
              const inviteText = `Hi，\n\n想邀请你体验一下我最近在使用的全球客户沟通工具 —— MailTalk。\n\n立即注册体验：\n\n👉 {{INVITE_LINK}}\n\nMailTalk 专为国际贸易与全球客户营销场景打造，集「邮件收发、即时通讯、客户管理、团队协作、文件共享」于一体，帮助企业更高效地连接全球客户、提升沟通效率与团队协作能力。

【为什么选择 MailTalk？】

✅ 集成多种沟通方式
融合商务邮件与即时聊天，支持多渠道触达。添加客户即可开启实时沟通，让联系更高效、响应更及时，快速抢占商机。

✅ 支持全球主流邮箱
轻松绑定企业邮箱，并支持 Gmail、Outlook、Hotmail 等国际邮箱一键登录。实现邮件统一收发与集中管理，确保不遗漏任何客户需求。

✅ 客户管理更清晰
支持客户归档、联系人管理、分类营销，帮助团队系统化沉淀客户资源。

✅ 团队协作更高效
支持多公司、多团队管理，实现客户分配、权限管理与工作流协同，提高团队执行效率。

✅ 文件共享更便捷
超大文件、邮件附件可快速存储与共享，沟通资料随时查看。

✅ 数据安全更安心
客户信息与沟通记录支持安全本地存储，保障业务数据安全。

期待你加入 MailTalk，开启更高效的全球客户沟通体验！\n\n—— MailTalk Team`
              const inviteHtml = inviteText
                .replace(/\n/g, '<br>')
                .replace(
                  '{{INVITE_LINK}}',
                  `<a href="${safeInviteLink}" target="_blank" rel="noopener noreferrer">${safeInviteLink}</a>`
                )
              editor.setContent(inviteHtml)
            }
          }
          intervalId = setInterval(autoSaveDraft, 60000); // 每45秒调用一次保存草稿
        }
      } catch (e) {
        console.error("❌ 邮件内容初始化失败：", e)
      } finally {
        isLoadingPage.value = false
      }
    });

    const autoSaveDraft = async () => {
      var timestamp = Date.now();
      const subject = form.subject.trim()
      const data = {
        ...form,
        subject: subject,
        to: mapRecipients(form.to, "to"),
        cc: form.cc ? mapRecipients(form.cc, "cc") : [],
        bcc: form.bcc ? mapRecipients(form.bcc, "bbc") : [],
        multipartFiles: multipartFiles.value,
        groupId: '10',
        userId: configMapSysUser[form.configId],
        from: userNameMap[form.configId],
        // 获取的当前内容 + 后续未展示的内容
        text: (getTinyEditorInstance(tinyEditorWrite)?.getContent() || '') + (injector.value !== '' ? injector.value.getStatus().remainingContent : ''),
        teamId: teamId.value,
        followDay: followDayFlag.value === 1 ? trueTargetFollowDay.value : 0,
        isRepeat: route.query.mailType === "2" || route.query.mailType === "3" ? 1 : 0,
        timeKey: timestamp,
        id: id.value
      };
      // data.text = sliceHtmlSafely(data.text, SLICE_NUMBER)
      //保存草稿
      saveDraft(data).then(res => {
        id.value = res.result.id;
      }).catch(e => {
        console.log(e)
      })
    }


    onUnmounted(() => {
      templateRef.value && templateRef.value.$refs.bodyWrapper.removeEventListener("mousewheel", scrollBehavior)
      // 消除定时器
      if (intervalId) {
        clearInterval(intervalId);
      }
    })


    // 附件预览
    const handleDetailFile = (item) => {
      const {url, name} = item
      // 获取扩展名
      const fileExtend = name.substring(name.lastIndexOf(".") + 1).toLocaleLowerCase()
      console.log(item, imgFormat.includes(fileExtend), fileExtend, 'item')

      if (imgFormat.includes(fileExtend)) {
        // 图片预览
        showTargetFile(item)
      } else if (pdfFormat.includes(fileExtend)) {
        // pdf
        //预览
        showTargetPdf(item);
      } else if (wordFormat.includes(fileExtend) || excelFormat.includes(fileExtend) || pptFormat.includes(fileExtend)) {
        // /world/excel
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(item.url))
      } else if (textFormat.includes(fileExtend)) {
        showTargetText(item)
      } else if (videoFormat.includes(fileExtend)) {
        showTargetVideo(item)
      } else if (audioFormat.includes(fileExtend)) {
        showTargetAudio(item)
      } else {
        // alert('下载')
        handleDownload(item.url, item.name)
      }
    }

    const openNewWindow = (url) => {
      window.open(url, "_blank");
    };
    const buildOpenUrl = (path, row, extra = "") => {
      if (!row || !row.url || !row.name) {
        console.error("row 不完整:", row);
        return "";
      }

      // http → https（只替换 http://）
      const safeUrl = row.url.replace(/^http:\/\//i, "https://");

      // 获取扩展名
      const ext = row.name.substring(row.name.lastIndexOf(".") + 1).toLowerCase();

      return `${location.origin}/${path}`
          + `?url=${encodeURIComponent(safeUrl)}`
          + `&type=${encodeURIComponent(ext)}`
          + extra;
    };

    const showTargetPdf = (row) => {
      openNewWindow(buildOpenUrl("showfile", row));
    };

    const showTargetText = (row) => {
      openNewWindow(buildOpenUrl("showtext", row));
    };

    const showTargetVideo = (row) => {
      openNewWindow(buildOpenUrl("showvideo", row));
    };

    const showTargetAudio = (row) => {
      openNewWindow(
          buildOpenUrl("showaudio", row, `&title=${encodeURIComponent(row.name)}`)
      );
    };


    const showTargetFile = (row) => {
      // alert(row.name)
      let images = [];
      let initialViewIndex = 0;

      // 过滤出非文件夹的文件
      multipartFiles.value.filter(_ => imgFormat.includes(_.name.substring(_.name.lastIndexOf(".") + 1).toLocaleLowerCase())).forEach((o, i) => {
        if (o.name === row.name) initialViewIndex = images.length
        images.push({src: o.url})
      })
      console.log(images, 'images')
      viewerApi({
        images,
        options: {
          initialViewIndex
        }
      })
    }

    function getDisplayValue(val) {
      // 处理空数组、null、undefined 等情况
      if (Array.isArray(val) && val.length === 0) return ''
      return val ?? ''
    }

    function isOverflowing(text) {
      return typeof text === 'string' && text.length > 30 // 根据实际情况调整
    }


    async function handleCurrentChange(page) {
      const {pageNo, pageSize} = page
      templatePageNo.value = pageNo
      templatePageSize.value = pageSize
      //  重新获取数据
      await getMailTemplateList()
    }

    // 判断当前 item 是否选中
    function isSelected(email) {
      // return selectedEmails.value.has(email)
      return [...form.bcc, ...form.to, ...form.cc]?.includes(email)
    }

    // 动态计算 ruleFormRef 的高度
    const listHeight = ref(85)

    function updateListHeight() {
      if (ruleFormRef?.value) {
        const formEl = ruleFormRef.value.$el ?? ruleFormRef.value
        const formHeight = formEl.offsetHeight
        listHeight.value = formHeight - 80
      }
    }


    // 侧边 ai
    const drawer = ref(true)
    const isExpand = ref(false)
    const smallAIHeight = ref('180px')
    const smallAIWidth = ref("350px")
    const handleAmplify = () => {
      if (isExpand.value) {
        smallAIHeight.value = '180px'
        smallAIWidth.value = '350px'
        isExpand.value = false
      } else {
        smallAIHeight.value = '82vh'
        smallAIWidth.value = '32vw'
        isExpand.value = true
      }
    }

    const handleClickCloseChat = () => {
      drawer.value = false
    }

    const handleClickAIButton = () => {
      drawer.value = !drawer.value
    }

    const handleEmailFocus = () => {
      isExpand.value = false
      handleAmplify()
    }

    const handleEmailAIInsertContentToTinyMCE = (html) => {
      const editor = tinyEditorWrite.value?.tinyMCEEditor?.getEditor();
      if (editor) {
        // editor.setContent(html)
        // editor.insertContent(html)
        editor.selection.setContent(html)
      }
    }

    return {
      currentTargetEmailDetail,
      handleEmailAIInsertContentToTinyMCE,
      handleEmailFocus,
      handleClickAIButton,
      isExpand,
      smallAIWidth,
      smallAIHeight,
      handleClickCloseChat,
      handleAmplify,
      drawer,
      topMessageLoading,
      TargetEmailTemplate,
      errorEmailsTo,
      errorEmailsCc,
      errorEmailsBcc,
      isUnRegTo,
      isUnRegBcc,
      isUnRegCc,
      rules,
      isValidEmail,
      pageLoading,
      handleClickDel,
      isLoadingPage,
      listHeight,
      isSelected,
      lang,
      handleCurrentChange,
      handleCurrentChangeTemplate,
      templatePageNo,
      templatePageSize,
      total,
      getDisplayValue,
      isOverflowing,
      searchTeam,
      handleSearchTeam,
      iframeScroll,
      loadingListText,
      emptyListText,
      noMoreText,
      customerIsCurrentInputLoading,
      tableDataTeamLoading,
      showCustomerNoMore,
      showTeamNoMore,
      handleScrollTeam,
      tableDataTeam,
      loadMore,
      loadingMore,
      noMore,
      showPagination,
      customerListInput,
      handleSearchCustomerInput,
      handleTop,
      subject,
      handleDetailFile,
      tinyEditorTemplateContentHtml,
      tinyEditorTemplate,
      tinyEditorWriteContentHtml,
      tinyEditorWriteContentHtmlComputed,
      tinyEditorWrite,
      followDayFlag,
      trueTargetFollowDay,
      List,
      handleScroll,
      templateRef,
      isLoading,
      handleTableScroll,
      ruleFormRef,
      contentLoading,
      isEmailReg,
      customerLoading,
      beforeUpload,
      form,
      userMail_dropDownOptionList,
      open,
      action,
      templateFlag,
      addTemplateFlag,
      previewFlag,
      previewContent,
      editTemplate,
      templateName,
      currentTemplateMail,
      templateList,
      customerList,
      multipartFiles,
      isUploadedFile,
      sendNum,
      sendDate,
      filesRef,
      customerName,
      token:
          getToken(),
      handleSearchCustomer,
      handleSetOpen,
      handleDelMul,
      handleSendDateChange,
      handleFocus,
      handleBlur,
      handleDel,
      handleView,
      handleInitTemplateEditor,
      handleUse,
      handleSaveTemplate,
      handleEditTemplate,
      disabledDate,
      handleSelectTemplate,
      handleCurrentRowChange,
      handleSetDefault,
      handleSendMail,
      handleSelectCustomer,
      handleUploadError,
      handleUploadSuccess,
      onProgress,
      uploadCompleted,
      loadingSend,
      loadingExamine,
      loadingSave,
      writeSelectTargetFileDialog,
      closeWriteSelectTargetFileDialog,
      handleClickSelectFileFromCloud,
      getSelectTargetFile,
      downloadFiles,
      isLoadingAdd,
      visibleDialog,
      createNewTask,
      close,
      calcelEditor,
      uploadProgress,
    }
  }
}
</script>

<style lang="less" scoped>
@import "./less/write_mail";

.upload-demo {
  height: 100% !important;
}

.demo-tabs {
  height: 100% !important;

  #pane-customer {
    height: 100% !important;
  }
}

:deep(.el-upload-dragger) {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100% !important;
}

:deep(.el-upload--text) {
  height: 100% !important;
}

:deep(.el-upload-dragger) {
  border: none !important;
}

:deep(.el-overlay:nth-of-type(1)) {
  z-index: 90 !important;
}

:deep(.el-overlay:nth-of-type(2)) {
  z-index: 99 !important;
}

iframe {
  border: none !important;
}

:deep(.el-dialog__title) {
  font-size: 14px !important;
  font-weight: normal !important;
}

:deep(.el-dialog__headerbtn) {
  font-size: 20px !important; /* 调整关闭按钮大小 */
}

:deep(.el-dialog__headerbtn .el-dialog__close) {
  color: #252f3d !important;
}

.popover-content {
  max-width: 300px;
  max-height: 200px;
  overflow-y: auto;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
}

.label {
  font-size: 13px !important;
  font-weight: normal !important;
  line-height: 30px !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

.item {
  :deep(.el-tooltip__trigger) {
    overflow: hidden !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
  }
}

.item.is-selected {
  background-color: #f4f4f5;
}

.mailselectEl_error {
  transition: all .3s;
  border: 1px solid transparent !important;
  border-radius: 2px !important;
}

.mailselectEl {
  transition: all .25s;
  border: 1px solid #f56c6c !important;
  border-radius: 4px !important;
  box-shadow: 0 0 0 1px rgba(245, 108, 108, 0.3);
}

.ai_button {
  position: relative;
  padding: 0 10px;
  width: 86px;
  height: 24px;
  line-height: 24px;
  color: #fff;
  border-radius: 2px;
  cursor: pointer;
  overflow: hidden;

  /* 底层渐变 */
  background: linear-gradient(225deg, #32C5FF 0%, #B620E0 100%);
}

.ai_button::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(225deg, #B620E0 0%, #32C5FF 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1; /* 在背景之上 */
}

.ai_button div {
  position: relative;
  z-index: 2; /* 永远在最上面 */
}

.ai_button:hover::after {
  opacity: 1;
}

.gj_loading {
  padding: 10px 0px;
  margin: 5px 0px;
}

.select-dropdown-status {
  padding: 6px 20px 8px;
  font-size: 13px;
  line-height: 20px;
  color: #909399;
}

.side-status {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  padding: 12px;
  color: #909399;
  font-size: 13px;
  text-align: center;
}

.side-status_empty {
  min-height: 120px;
}

.side-status_footer {
  min-height: 40px;
  padding: 8px 12px 12px;
}

.file-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  padding: 16px 12px;
  color: #909399;
  font-size: 13px;
  text-align: center;
}

:deep(.file-empty .el-empty) {
  padding: 0;
}

:deep(.file-empty .el-empty__description) {
  display: none;
}

.file_box_upload {
  position: relative;
}

.files_out_box_layer {
  position: absolute;
  inset: 0;
  z-index: 80;
  pointer-events: none;
}

.file-item {
  pointer-events: auto;
}

.file-empty_hint {
  pointer-events: none;
}

.drop_area_upload {
  position: relative;
  z-index: 1;
}

.list_team::-webkit-scrollbar {
  width: 4px;
}

.list_team::-webkit-scrollbar-track {
  background: white;
}

.list_team::-webkit-scrollbar-thumb {
  background: #7f7f7f;
  border-radius: 4px;
}

.list_team::-webkit-scrollbar-thumb:hover {
  background: #dedddd;
}
</style>
